<template>
  <div class="fixed-layout">
    <div class="content">
      <div class="title mt-3 mb-4">
        <p class="h2"><b>Find your username</b></p>
      </div>

      <div class="text mb-4">
        <p class="h6">Enter your email.</p>
      </div>

      <form novalidate @submit.prevent="submitForm">
        <div class="form-floating mb-4">
          <input
              type="text"
              class="form-control"
              id="email"
              v-model="email"
              placeholder="name@example.com"
              required
          />
          <label for="email">
            <span style="color: red">*</span> Email address(name@example.com)
          </label>
        </div>

        <div ref="EMAIL" class="check red" role="alert">&nbsp;</div>
      </form>
    </div>

    <div class="buttons">
      <div class="row">
        <div class="col mb-3">
          <button
              type="button"
              class="btn btn-outline-dark btn-lg rounded-pill w-100"
              @click="cancelClick"
          >
            Cancel
          </button>
        </div>

        <div class="col mb-3">
          <button
              type="submit"
              class="btn btn-dark btn-lg rounded-pill w-100"
              :disabled="email === ''"
              @click="submitForm"
          >
            Submit
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { router } from "@/router/index.js";
import { $error } from "@/dot-ui/index.js";

export default {
  props: { fromParams: Object },
  data() {
    return { email: "" };
  },
  methods: {
    submitForm() {
      $error.clearForm("check");
      if (!this.email.trim()) {
        this.$refs.EMAIL.innerHTML = "Email address is required.";
        return;
      }
      this.$emit("submitEmail", this.email);
    },
    cancelClick() {
      router.go(-1);
    },
  },
};
</script>

<style>
.check {
  width: 100%;
  white-space: normal;
  word-break: break-word;
}
</style>
